import {useMemo, useContext, useId, useState} from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../../../../hooks/react-redux'
import {DisabledContext} from '../../../../../../../contexts/DisabledContext'
import {pipelineDraft} from '../../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../../hooks/pipeline'

function usePipelineParameter(name: string) {
  const id = useId()
  const pipelineId = usePipelineId()
  const dispatch = useAppDispatch()
  const [isEditMode, setEditMode] = useState(false)
  const isDisabled = useContext(DisabledContext)
  const renamedParameters = useAppSelector(
    state => state.pipelines.pipelineDraft[pipelineId]?.renamed?.parameters,
  )
  const currentParameterName = useMemo(
    () => renamedParameters?.[name] ?? name,
    [name, renamedParameters],
  )
  const buttonEditClickHandler = () => setEditMode(state => !state)
  const deleteButtonClickHandler = () => {
    dispatch(pipelineDraft.actions.deleteParameter({id: pipelineId, name}))
    setEditMode(false)
  }
  const buttonConfirmClickHandler = (newName: string, newValue: string) => {
    dispatch(
      pipelineDraft.actions.changeParameter({
        id: pipelineId,
        name: newName,
        value: newValue,
        savedName: currentParameterName,
      }),
    )

    setEditMode(false)
  }
  const buttonRestoreClickHandler = () =>
    dispatch(pipelineDraft.actions.restoreParameter({id: pipelineId, name}))

  return {
    id,
    isEditMode,
    isDisabled,
    pipelineId,
    currentParameterName,
    buttonConfirmClickHandler,
    buttonEditClickHandler,
    deleteButtonClickHandler,
    buttonRestoreClickHandler,
  }
}

export default usePipelineParameter
